
<app-sidebar (onCloseMenu)="showSidebar = $event" [show]="showSidebar"></app-sidebar>
<div class="relative flex flex-col flex-1 overflow-x-hidden overflow-y-hidden">
  <app-navbar [(showSidebar)]="showSidebar"></app-navbar>
  <main class="flex w-full h-full overflow-hidden">
    <router-outlet></router-outlet>
  </main>
</div>
